import { createContext, useContext } from 'react'

export type SaveFABContextValue = {
  hasSaveFAB: boolean
  setHasSaveFAB: (value: boolean) => void
  /**
   * true só se houver overlay fixo cobrindo o conteúdo.
   * SaveFAB fica no fluxo do scroll — permanece false.
   */
  needsFloatingPadding: boolean
  setNeedsFloatingPadding: (value: boolean) => void
}

export const SaveFABContext = createContext<SaveFABContextValue | null>(null)

export function useSaveFABContext(): SaveFABContextValue {
  const ctx = useContext(SaveFABContext)
  if (!ctx) {
    return {
      hasSaveFAB: false,
      setHasSaveFAB: () => {},
      needsFloatingPadding: false,
      setNeedsFloatingPadding: () => {},
    }
  }
  return ctx
}
